module.exports = __webpack_public_path__ + "img/sale-button-03.7d2a5018.png";